import { useTranslation } from 'react-i18next'

import { observer } from 'mobx-react-lite'

import { DOCUMENT, IDocument } from 'entities/user/module'
import userStore from 'entities/user/module/user-store'

import { IProfileTypes, ProfileTypes } from 'shared/constants'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { Paper } from 'shared/ui/paper'

import { renderProfileInfo } from './lib/renderProfileInfo'
import styles from './styles.module.scss'

type Props = {
  type: IProfileTypes | undefined
}

export const ViewDetailForm = observer(({ type }: Props) => {
  const { t } = useTranslation()

  const isPass = type === ProfileTypes.PASS.key

  let accountData: Partial<IDocument> | undefined = isPass
    ? userStore.account?.id_card
    : userStore.account?.international_passport

  if (!accountData) {
    accountData = {
      ...userStore.account?.id_card,
      document_number: '',
      document_expire: '',
      document_type: DOCUMENT.PASSPORT,
    }
  }

  const itemDetail = renderProfileInfo(accountData as IDocument)

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeaderGoBack
          title={t(ProfileTypes[type!].name)}
          buttonWhite
        />
      </div>

      <Paper padding={[8, 0, 8, 16]}>
        <div className={styles.itemDetails}>
          {itemDetail.map((item) => (
            <div
              key={item.id}
              className={styles.itemDetailsContent}
            >
              <span>{t(item.title)}</span>

              <p>{item.content ? t(item.content) : '-'}</p>
            </div>
          ))}
        </div>
      </Paper>
    </div>
  )
})
